module.exports = __webpack_public_path__ + "static/media/send.50043e21.svg";